import './src/js/setPublicPath';
import { GamedayAppBase } from '@gameday/app';
import initClient from 'bdata-react-component';
import { DataEngine } from '@gameday/core';
import componentMap from './src/componentMap';
import siteConfig from './src/js/site-config-options';
import changeConfigAction from '@gameday/app/lib/store/actions/config';
import AdvertisingUtils, { stateToPageid } from '@gameday/ads/lib/AdvertisingUtils';
import './lib/styles/app.css';

const getAdsCoverride = (defaultAdsConfig, storeData) => {
    const {
        config: {
            locale,
            deviceType
        } = {},
        gumbo: {
            liveData: {
                linescore: {
                    currentInning,
                    inningState
                }
            },
            gameData: {
                teams,
                game: {
                    pk
                },
                status: {
                    abstractGameState
                }
            } = {}
        } = {}
    } = storeData;

    const adsOverride = AdvertisingUtils.getKeyVals({ inningState, teams, currentInning, gamePk: pk, gameState: abstractGameState });
    const gameState = stateToPageid[abstractGameState.toLowerCase()];

    return {
        ...defaultAdsConfig,
        ...{
            targeting: {
                locale,
                devicetype: deviceType,
                pathname: window.location.pathname.split('/').splice(1),
                ...adsOverride?.pageTargeting,
                pageid: gameState
            }
        }
    };
};

class GamedayApp extends GamedayAppBase {
    constructor (opts) {
        super(opts);

        const moreOpts = {
            componentMap,
            DataEngine
        };

        const _root = initClient(this.appContainer, { ...this.opts, ...moreOpts });
        this.init(_root);
    }
}

export const bootstrap = function () {
    const app = new GamedayApp({ ...siteConfig.game, config: siteConfig.config, mount: siteConfig.mount, tracking: siteConfig.tracking });
    app.prefetch().then(() => {
        app.render();
    }).then(() => {
        app.store.dispatch(changeConfigAction({ ads: getAdsCoverride(siteConfig.ads, app?.store?.getState() || {}) }));
        if (window?.team_info) {
            app.store.dispatch(changeConfigAction({ teamInfo: window?.team_info }));
        }
    });
};

export default GamedayApp;
